// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o3-1";
export var stateContainer = "_o3-0";